export const DraftStatusIcon: React.FC = ({}) => {
    return(
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 17.995">
        <path id="Caminho_271" data-name="Caminho 271" d="M17.506,2.612,15.395.5a1.692,1.692,0,0,0-2.388,0L11.02,2.487l4.472,4.5L17.478,5a1.662,1.662,0,0,0,.035-2.388Zm-7.282.671-9.13,9.13a.564.564,0,0,0-.152.291L.014,17.328a.56.56,0,0,0,.658.665L5.3,17.065a.592.592,0,0,0,.291-.152l9.13-9.13-4.5-4.5Z" transform="translate(-0.002 -0.007)" fill="#114d88" />
      </svg>
  )
}